<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'SalesInventoryCheckShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'sales_inventory_check_sim_cards', tabName: 'SIM卡核库' },
        { routeName: 'sales_inventory_check_modules', tabName: '模组核库' },
        { routeName: 'sales_inventory_check_cpes', tabName: 'CPE核库' }
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
